import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { map, Observable, switchMap, take } from 'rxjs';
import { Profile } from 'src/app/api/contracts/client';
import { Order } from 'src/app/api/contracts/order';
import { AuthService } from 'src/app/auth/auth.service';
import { TabsModel } from 'src/app/components/UI/tabs/tabs.types';
import { ClientService } from 'src/app/services/client.service';
import { ModalService } from 'src/app/services/modal.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss'],
})
export class MyOrdersComponent implements OnInit {
  public readonly profile$: Observable<Profile>;
  public readonly subsidyAmount$: Observable<number | null>;
  public readonly userOrders$: Observable<Order[]>;

  public readonly tabsModel: TabsModel = {
    tabs: [
      // {
      //   index: 0,
      //   i18nLabel: '@pages.myOrders.tabs.todaysDeliveries',
      // },
      {
        index: 1,
        i18nLabel: '@pages.myOrders.tabs.myOrders',
      },
    ],
    activeTabIndex: 1,
  };

  constructor(
    private readonly clientService: ClientService,
    private readonly authService: AuthService,
    private readonly modalService: ModalService,
    private readonly navCtrl: NavController,
    private readonly orderService: OrderService
  ) {
    this.profile$ = this.clientService.profile$;
    this.subsidyAmount$ = this.clientService.clientSubsidies$.pipe(
      map((clientSubsidies) =>
        clientSubsidies.reduce((acc, n) => (acc += n.subsidy), 0)
      )
    );
    this.clientService.retrieveClientSubsidies().subscribe();
    this.userOrders$ = this.orderService.retrieveOrders();
  }

  ngOnInit() {
    return;
  }

  onLogout(): void {
    this.authService.logout().subscribe();
  }

  onSubsidyInfoClicked(): void {
    this.subsidyAmount$
      .pipe(
        take(1),
        switchMap((amount) => this.modalService.showSubsidyInfoModal(amount!))
      )
      .subscribe();
  }

  onManageSubsidiesClicked(): void {
    this.navCtrl.navigateForward('subsidies');
  }

  onSelectTab(tabIndex: number): void {
    this.tabsModel.activeTabIndex = tabIndex;
  }

  onGoToProfileSettings(): void {
    this.navCtrl.navigateForward('profile');
  }
}
